export function redactParams(object, redactedParams) {
  const newObject = {...object};

  Object.keys(object).map((key) => {
    if (redactedParams.includes(key)) {
      newObject[key] = '[REDACTED]';
    }
  });

  return newObject;
}